import { Box, Heading, Image, Text } from "@chakra-ui/react";

export const Homeservices = () => {
  return (
    <Box w={"100%"} bgColor={"whiteAlpha.800"} zIndex={"0"}>
      <Box width={"60%"} margin={"auto"} zIndex={"20"} pb={"50px"}>
        <Heading mt={"90px"} width={"100%"} textAlign={"center"}>
          {/* Home Services */}
          &nbsp;
        </Heading>
        <Box>
          <Box
            height={"150px"}
            width={"70%"}
            display={"flex"}
            backgroundColor={"white"}
            zIndex={"1"}
            margin={"auto"}
            mt={"130px"}
            gap={"50px"}
            p={"10"}
          >
            <Box alignItems={"center"} justifyContent={"center"} margin={"auto"}>
              <Image
                src="https://res.cloudinary.com/urbanclap/image/upload/q_auto,f_auto,fl_progressive:steep,w_64/t_high_res_template/categories/category_v2/category_72d18950.png"
                w={"32px"}
                h={"32px"}
                margin={"auto"}
                mb={"10px"}
              />
              <Text textAlign={"center"} fontSize={"small"} color={"black"}>
                Applience Repair
              </Text>
            </Box>
            <Box alignItems={"center"} justifyContent={"center"} margin={"auto"}>
              <Image
                src="https://res.cloudinary.com/urbanclap/image/upload/q_auto,f_auto,fl_progressive:steep,w_64/t_high_res_template/images/growth/home-screen/1631679515206-a69389.png"
                w={"32px"}
                h={"32px"}
                margin={"auto"}
                mb={"10px"}
              />
              <Text textAlign={"center"} fontSize={"small"} color={"black"}>
                Home Painting
              </Text>
            </Box>
            <Box alignItems={"center"} justifyContent={"center"} margin={"auto"}>
              <Image
                src="https://res.cloudinary.com/urbanclap/image/upload/q_auto,f_auto,fl_progressive:steep,w_64/t_high_res_template/categories/category_v2/category_6b1f5250.png"
                w={"32px"}
                h={"32px"}
                margin={"auto"}
                mb={"10px"}
              />
              <Text textAlign={"center"} fontSize={"small"} color={"black"}>
                Cleaning & Past
              </Text>
            </Box>
            <Box alignItems={"center"} justifyContent={"center"} margin={"auto"}>
              <Image
                src="https://res.cloudinary.com/urbanclap/image/upload/q_auto,f_auto,fl_progressive:steep,w_64/t_high_res_template/images/growth/home-screen/1641213886588-90a903.png"
                w={"32px"}
                h={"32px"}
                margin={"auto"}
                mb={"10px"}
              />
              <Text textAlign={"center"} fontSize={"small"} color={"black"}>
                Disinfection
              </Text>
            </Box>
            <Box alignItems={"center"} justifyContent={"center"} margin={"auto"}>
              <Image
                src="https://res.cloudinary.com/urbanclap/image/upload/q_auto,f_auto,fl_progressive:steep,w_64/t_high_res_template/categories/category_v2/category_6fbad370.png"
                w={"32px"}
                h={"32px"}
                margin={"auto"}
                mb={"10px"}
              />
              <Text textAlign={"center"} fontSize={"small"} color={"black"}>
                Home Repairs
              </Text>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
